




























import Vue from 'vue';
import {Location} from '@/Stores/UserStore';
import {redirectRetiredLocation} from '@/Shared/Redirection';

const component = Vue.extend({
    beforeMount() {
        this.checkLocation();
    },
    props: {
        destinationRoute: {
            type: String,
            required: true
        },
        location: {
            type: String as () => (string | undefined)
        },
        unknownLocation: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    computed: {
        loggedIn(): boolean {
            return this.$typedStore.modules.userModule.getters.userName ? true : false;
        },
    },
    data() {
        return {
            selectedLocation: null as Location | null,
            locations: [] as Location[]
        };
    },
    methods: {
        async checkLocation() {
            this.locations = await this.$typedStore.modules.userModule.actions.getAllowedLocations();
            if (!this.location) {
                return;
            }
            this.selectedLocation = this.locations
                .find(item => item.urlSegment.toUpperCase() === this.location?.toUpperCase()) || null;
            this.locationSelected();
        },
        async locationSelected() {
            if (this.selectedLocation && this.location !== this.selectedLocation.urlSegment) {
                await redirectRetiredLocation(this.selectedLocation?.urlSegment ?? '');
                this.$router.push({
                    name: this.destinationRoute,
                    params: {
                        ['location']: this.selectedLocation.urlSegment
                    }
                });
            }
        }
    },
    watch: {
        location() {
            this.checkLocation();
        }
    }
});

export default component;
